const RESTART_URL = "/welcome/v2/quiz/spain_scoring1";

const finalCold = {
  typeInfo: "noQuestions",
  title: "Por ahora no podemos ofrecerte el curso gratuito",
  subtitle:
    "Lamentablemente, para acceder al curso gratuito es necesario contar con una computadora portátil y una conexión estable a internet. Si no dispone de ellos, no será posible obtener ni realizar el curso.<br><br>Si respondió por error, puede volver a realizar el test e indicar que el niño o la niña sí cuenta con una computadora portátil y conexión a internet para las clases.",
  button: "Volver a empezar",
  buttonEvent: "scoringcold_restart_button",
  redirectUrl: RESTART_URL,
};

export default {
  newDesign: true,
  parameters: {
    segment: 54,
  },
  title: "Cursos de programación para niños de 8 a 17 años | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    footer: true,
    title: "Responde a algunas preguntas y obtén un curso gratuito de programación",
    subtitle:
      "Recibirás 3 lecciones interactivas y una sesión individual en línea con un tutor profesional",
    image: {
      url: "/welcome/spain_freecourse_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/spain_freecourse_v2_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Consigue el curso 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Tienen en casa una computadora o laptop para las clases?",
      answers: [
        {
          answer: "Sí, tenemos una computadora o laptop.",
          nextStep: 2,
        },
        {
          answer: "Por ahora, solo tenemos teléfono o tablet.",
          nextStep: 3,
        },
      ],
    },
    2: {
      question: "¿Qué tan estable es la conexión a internet en casa?",
      answers: [
        { answer: "Estable, normalmente sin problemas.", nextStep: 4 },
        { answer: "A veces se interrumpe.", nextStep: 4 },
        { answer: "Se interrumpe con frecuencia.", nextStep: 3 },
      ],
    },

    3: finalCold,

    4: {
      question:
        "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: ["🔥 ¡Si!", "🤗 No. Lo hace solo para divertirse y eso está bien"],
    },
    5: {
      question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
      answers: [
        "👍 No tiene conocimientos, debe estudiar lo básico",
        "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
        "🖥 Nivel intermedio, quiere profundizar conocimientos",
        "🕹 Usa los dispositivos más que nada para juegos",
      ],
    },
    6: {
      question:
        "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
      answers: [
        "🤔 Habilidades blandas",
        "🎓 Preparación para una carrera a futuro",
        "🖥 Actividades extracurriculares",
      ],
    },
    7: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    8: {
      title: "🎉 Regístrate para una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "¡Vamos a conocernos y mostrarte cómo funciona Kodland!<br>En la primera clase, tu hijo creará su propio minijuego y verá cómo son las actividades.<br>¡Y tú puedes acompañarlo!<br><br>👇 Completa tus datos para reservar.",
      button: " ¡Continuar! 🚀 ",
    },
    9: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    11: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    12: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo tienes que hacer clic en el enlace, te llevará directamente a la clase. Sin aplicaciones adicionales, sin descargas.",
      button: "Entendido ✅",
    },
    13: {
      question:
        "Si las clases resultan útiles para el niño/la niña, ¿estarían dispuestos a considerar clases regulares?",
      answers: [
        "Sí, ya estamos considerando esa posibilidad.",
        "Sí, si el precio es razonable.",
        "Aún no estamos seguros, necesitamos más información.",
        "No, no planeamos pagar, incluso si al niño/la niña le gusta.",
      ],
    },
  },
};
